import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { IdentityAuthProvider } from '@auth/IdentityAuthContext';

import App from '@/App';
import './styles/index.css';
import './i18n/config';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container missing in index.html');
}

// Service worker cleanup (for production builds)
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(registration => {
      registration.unregister();
    });
  });
}

const root = createRoot(container);
root.render(
  <StrictMode>
    <IdentityAuthProvider>
      <App />
    </IdentityAuthProvider>
  </StrictMode>
);
